var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-attention-circle-1';
                    var viewUrl = 'gfx/sprite.svg#view-icon-attention-circle-1';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 1000 1000',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };